module.exports = __webpack_public_path__ + "static/media/RA3.32f35980.gif";